import ResponseMessage from "@/components/Error/ResponseMessage";
import { HStack, Spacer, VStack } from "@/components/Layout";
import { TextVariant } from "@/components/Typography";
import { Text } from "@/components/Typography/Text";
import { cn } from "@/lib/cn";
import { defaultNS, useTranslation } from "@/lib/i18n";

type FormField = {
  fieldTitle?: string;
  titleVariant?: TextVariant;
  titleClassName?: string;
  fieldInput: React.ReactNode;
  optional?: boolean;
  errorMessage?: string;
  className?: string;
};

// TODO: person以外のルートでも使用されているので、共通コンポーネントもしくはfeaturesに配置する, その他の共通コンポーネントのformも整理する
export const FormField = ({
  fieldTitle,
  titleVariant = TextVariant.labelSmall,
  titleClassName,
  fieldInput,
  optional = false,
  errorMessage,
  className,
}: FormField) => {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "component.input",
  });

  return (
    <VStack className={`min-w-48 max-w-96 ${className}`}>
      {fieldTitle && (
        <>
          <HStack className="gap-2 items-center">
            <Text
              variant={titleVariant}
              className={cn(
                "font-semibold text-muted-foreground",
                titleClassName,
              )}
            >
              {fieldTitle} {optional && t("optional")}
            </Text>
          </HStack>
          <Spacer />
        </>
      )}
      {fieldInput}
      <ResponseMessage>{errorMessage}</ResponseMessage>
    </VStack>
  );
};
